import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt-br";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

interface Props {
  register: any;
  get: any;
  set: any;
  label: string;
  required?: boolean;
  disabled?: boolean;
  requiredtxt?: string;
  name: string;
}

const DatePickerField = (props: Props) => {
  let defaultValue = props.get(props.name);
  defaultValue = defaultValue ? dayjs(defaultValue) : null;
  const options: { required?: string } = {};

  if (props.required) {
    options.required = props.requiredtxt;
  }

  const { ref } = props.register(props.name, options);

  const handleChange = (event: any) => {
    if (!event) return;

    props.set(props.name, event.toISOString());
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <MobileDatePicker
        onChange={handleChange}
        slotProps={{
          textField: {
            inputRef: ref,
            size: "small",
            name: props.name,
            fullWidth: true,
            margin: "dense",
            defaultValue,
            required: props.required,
            disabled: props.disabled,
            label: props.label,
          },
        }}
      />
    </LocalizationProvider>
  );
};

DatePickerField.defaultProps = {
  required: false,
  disabled: false,
};

export default DatePickerField;
